import { graphql } from 'relay-runtime';

export const productStatusMutation = graphql`
    mutation puSwitchProductSetStatusMutation($input: SetStatusProductInput!) {
        setStatusProduct(input: $input) {
            model {
                id
                statusID
            }
            errors {
                ... on Error {
                    message
                }
            }
        }
    }
`;
